import type { DetailedCreditCard } from '@contracts/payment/CreditCard';
import type { TransactionCurrency } from '@contracts/payment/Currency';
import { PaymentClient } from '@src/orders/services/PaymentClient';
import { useQuery } from '@tanstack/react-query';

interface Props {
  clientId: string;
  currency?: TransactionCurrency;
}

export const useCreditCards = ({ clientId, currency }: Props) => {
  const {
    data: availableCreditCards = [],
    refetch,
    isLoading,
  } = useQuery<DetailedCreditCard[]>({
    queryKey: ['getCreditCards', clientId, currency],
    queryFn: () =>
      PaymentClient.getCreditCards({ clientId, currency: currency! }),
    enabled: !!currency,
  });

  return {
    availableCreditCards,
    refetch,
    isLoading,
  };
};
